module.exports = __webpack_public_path__ + "img/logo.e7075d54.png";